'use client'
import { __awaiter } from '../../../../../../../../_virtual/_tslib.js';
import { useCallback } from 'react';
import { useUserWallets } from '../../../../../../context/UserWalletsContext/UserWalletsContext.js';
import { useProjectSettings } from '../../../../../../store/state/projectSettings/projectSettings.js';
import { getWalletConnectorOptions } from '../../../../../../store/state/walletOptions/walletOptions.js';
import { useFunding } from '../../../../../../utils/hooks/useFunding/useFunding.js';
import { useWidgetContext } from '../../../../context/DynamicWidgetContext.js';

const useStartExternalWalletFunding = () => {
    var _a, _b;
    const userWallets = useUserWallets();
    const settings = useProjectSettings();
    const { connectWalletForFunding } = useFunding();
    const { setDynamicWidgetView } = useWidgetContext();
    return useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _c, _d;
        const hasWalletConnectWallet = userWallets.some((wallet) => wallet.connector.isWalletConnect);
        // WC does not allow multiple sessions, so we have 2 cases here:
        // 1. The user has a linked WalletConnect wallet.
        //    In this case, we should not do anything, and our logic will prevent other WCs from being
        //    selected for funding.
        // 2. The user does not have a WalletConnect wallet linked.
        //    In this case, we should reset the WC session — this is because they might have just
        //    previously connected another WC wallet for funding and that session could still be active.
        if (!hasWalletConnectWallet) {
            const walletOption = getWalletConnectorOptions().find(({ walletConnector }) => walletConnector.isWalletConnect);
            yield (walletOption === null || walletOption === void 0 ? void 0 : walletOption.walletConnector.endSession());
            yield (walletOption === null || walletOption === void 0 ? void 0 : walletOption.walletConnector.init());
        }
        try {
            const externalWallet = yield connectWalletForFunding();
            const minAmount = (_d = (_c = settings === null || settings === void 0 ? void 0 : settings.sdk.funding) === null || _c === void 0 ? void 0 : _c.externalWallets) === null || _d === void 0 ? void 0 : _d.minAmount;
            const recommendedToken = minAmount === null || minAmount === void 0 ? void 0 : minAmount.currency;
            const minValue = (minAmount === null || minAmount === void 0 ? void 0 : minAmount.amount)
                ? parseFloat(minAmount.amount)
                : undefined;
            setDynamicWidgetView('receive-external-wallet-funds', {
                amount: minValue ? { rule: 'minimum', value: minValue } : undefined,
                externalWallet,
                token: recommendedToken
                    ? {
                        rule: 'recommended',
                        value: recommendedToken,
                    }
                    : undefined,
            });
        }
        catch (_e) {
            /* empty */
        }
    }), [
        connectWalletForFunding,
        setDynamicWidgetView,
        (_b = (_a = settings === null || settings === void 0 ? void 0 : settings.sdk.funding) === null || _a === void 0 ? void 0 : _a.externalWallets) === null || _b === void 0 ? void 0 : _b.minAmount,
        userWallets,
    ]);
};

export { useStartExternalWalletFunding };
